var map = {
	"./Academy/locales/en.json": "6bcb",
	"./Academy/locales/fr.json": "cb81",
	"./Actionsboard/locales/en.json": "e619",
	"./Actionsboard/locales/fr.json": "f93a",
	"./Dev/locales/en.json": "cb5d",
	"./Dev/locales/fr.json": "d563",
	"./Hosting/locales/en.json": "4ef9",
	"./Hosting/locales/fr.json": "2037",
	"./Marketplace/locales/en.json": "6788",
	"./Marketplace/locales/fr.json": "fb93",
	"./Partnership/locales/en.json": "51ba",
	"./Partnership/locales/fr.json": "d393",
	"./Presence/locales/en.json": "c81c",
	"./Presence/locales/fr.json": "024f",
	"./Process/locales/en.json": "10bc",
	"./Process/locales/fr.json": "07e1",
	"./Quest/locales/en.json": "bbce",
	"./Quest/locales/fr.json": "23ae",
	"./Saas/locales/en.json": "c0b8",
	"./Saas/locales/fr.json": "44bc",
	"./Templates/locales/en.json": "ff88",
	"./Templates/locales/fr.json": "c148",
	"./Wiki/locales/en.json": "1b14",
	"./Wiki/locales/fr.json": "9f2b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8f70";